import React from "react";
import { DrawerProps } from "./Drawer.types";
import { BottomDrawer } from "./variants/BottomDrawer";
import { SideDrawer } from "./variants/SideDrawer";

export const Drawer: React.FC<DrawerProps> = (props) => {
  const { fields } = props;
  const { side_drawer_desktop } = fields || {};

  if (side_drawer_desktop) {
    return <SideDrawer {...props} />;
  }

  return <BottomDrawer {...props} />;
};
